import { Navigate } from 'react-router-dom';

import { SmallSpinner } from '../features/common';
import useCanAccessBankAccount from '../hooks/useCanAccessBankAccount';
import { ORDERS_HOME_PATH } from '../hooks/useClouderHomePath';

export default function BankAccountRoutesGuard({ children }) {
  const { canAccessBankAccount, isLoading } = useCanAccessBankAccount();

  if (isLoading) {
    return <SmallSpinner />;
  }

  if (!canAccessBankAccount) {
    return <Navigate to={ORDERS_HOME_PATH} replace />;
  }

  return children;
}
